import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';  

@Injectable({ providedIn: 'root' })
export class UserSchoolService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/DisAclUserSchools';
    constructor(private http: HttpClient) {
    }

    getAll(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/Get?' + queryString);
    }   
    getUsersSchoolById(id: any): Observable<any> {
        return this.http.get(this.url + `/GetById/${id}`, this.httpOptions);
    }

    addMultipleQuyen(model): Observable<any> {
        return this.http.post(this.url + `/AddMultiple`, model, this.httpOptions);
    }

    deleteMulti(listId: number[]): Observable<any> {
        return this.http.post(this.url + `/DeleteMulti`, listId, this.httpOptions);
    }
}
